import { Checkbox } from '../Checkbox'

import * as styles from './AICheckbox.module.css'

function AICheckbox({
  className = styles.aiCheckbox,
  iconClassName = styles.aiBounding,
  ...restProps
}) {
  return (
    <Checkbox
      {...restProps}
      className={className}
      iconClassName={iconClassName}
    />
  )
}

export default AICheckbox
